import React, {Fragment, useEffect, useMemo, useState} from "react";
import "./style.scss";

import Tier from "../../components/FundingEvaluation/Plans/Tier";
import LoaderOverlay from "../../reusableComponents/Loader";
import {useDispatch, useSelector} from "react-redux";
import ErrorModal from "../../reusableComponents/ErrorModal";
import Tabination from "../../reusableComponents/Tabination";
import {TOGGLE_Brand} from "../../store/reducers/brandSlice";
import {useNavigate} from "react-router-dom";
import TradingCupInfo from "./TradingCupInfo/TradingCupInfo";

function Plans({plans, activeTab, tabItems, setActiveTab}) {
  const [activeTier, setActiveTier] = useState(null);

  const plansRedux = useSelector((state) => state?.account?.plans);
  const userCountry = useSelector((state) => state?.user?.country);

  const [errorModalOpen, setErrorModalOpen] = useState(plansRedux.error);
  const [isLoading, setIsLoading] = useState(plansRedux.loading);

  // Build plan groups from Redux plans data: first by Plan Name (Legacy, Flagship, Swift, Instant), then Step (1_step, 2_step, pro_edge)
  const allPlans = useMemo(() => plansRedux?.data || [], [plansRedux?.data]);
  const baseName = (name) => {
    if (!name) return "";
    return name.replace(/^\s*(?:1|2)\s*Step\s*/i, "").trim();
  };

  // const planNames = useMemo(() => Array.from(new Set(allPlans.map((p) => baseName(p?.name)))), [allPlans]);

  const planNames = useMemo(() => {
    const desiredOrder = ["Legacy", "Swift", "Instant", "Flagship"];
    const uniqueNames = Array.from(new Set(allPlans.map((p) => baseName(p?.name))));
    return uniqueNames.sort((a, b) => {
      const indexA = desiredOrder.indexOf(a);
      const indexB = desiredOrder.indexOf(b);
      if (indexA === -1 && indexB === -1) return a.localeCompare(b);
      if (indexA === -1) return 1;
      if (indexB === -1) return -1;
      return indexA - indexB;
    });
  }, [allPlans]);

  const planBadges = {
    Legacy: "Most Popular",
    Flagship: "Highest Leverage",
    Swift: "Most Affordable",
    Instant: "Quickest to Payout",
  };

  console.log(planNames, "planNames");
  const [selectedPlanName, setSelectedPlanName] = useState(planNames?.[0] || "");
  useEffect(() => {
    if (planNames?.length && !planNames.includes(selectedPlanName)) {
      setSelectedPlanName(planNames[0]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [planNames.join(",")]);

  const plansForSelectedName = useMemo(() => allPlans.filter((p) => baseName(p?.name) === selectedPlanName), [allPlans, selectedPlanName]);

  const stepTypes = useMemo(() => Array.from(new Set(plansForSelectedName.map((p) => p?.type).filter(Boolean))), [plansForSelectedName]);
  const stepLabel = (type) => (type === "1_step" ? "1 Step" : type === "2_step" ? "2 Step" : type === "pro_edge" ? "Instant" : null);
  console.log(stepTypes, "stepTypesstepTypes");
  const [selectedStepType, setSelectedStepType] = useState(() => {
    if (stepTypes.includes("1_step")) return "1_step";
    if (stepTypes.includes("2_step")) return "2_step";
    return stepTypes?.[0] || null; // could be 'pro_edge'
  });
  useEffect(() => {
    if (!stepTypes.length) {
      setSelectedStepType(null);
      return;
    }
    if (!selectedStepType || !stepTypes.includes(selectedStepType)) {
      setSelectedStepType(stepTypes.includes("1_step") ? "1_step" : stepTypes[0]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stepTypes.join(","), selectedPlanName]);

  const currentPlan = useMemo(() => {
    if (!plansForSelectedName.length) return null;
    return plansForSelectedName.find((p) => (selectedStepType ? p?.type === selectedStepType : true)) || plansForSelectedName[0];
  }, [plansForSelectedName, selectedStepType]);

  const challenges = useMemo(() => currentPlan?.challenges || [], [currentPlan]);
  // Debug logs
  useEffect(() => {
    console.log(
      {
        planNames,
        selectedPlanName,
        stepTypes,
        selectedStepType,
        currentPlanName: currentPlan?.name,
        challengesCount: challenges?.length,
      },
      "Plans debug",
    );
  }, [planNames, selectedPlanName, stepTypes, selectedStepType, currentPlan, challenges]);

  useEffect(() => {
    setIsLoading(plansRedux.loading);
    setErrorModalOpen(plansRedux.error);
  }, [plansRedux]);
  const [footerValue, setFooterValue] = useState();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    if (isLoading) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [isLoading]);

  const isSwift = false;

  // Determine trading platforms based on user country and swift plan
  let tradingPlatform = [];
  if (selectedPlanName === "Trading Cup") {
    tradingPlatform = [{value: "mt5", label: "MT5"}];
  } else if (userCountry === "Poland") {
    tradingPlatform = [{value: "mt5", label: "MT5"}];
  } else if (userCountry === "Malaysia") {
    tradingPlatform = isSwift
      ? [{value: "mt5", label: "MT5"}]
      : [
          {value: "mt5", label: "MT5"},
          {value: "matchtrade", label: "Match-Trader"},
        ];
  } else {
    tradingPlatform = isSwift
      ? [{value: "mt5", label: "MT5"}]
      : [
          {value: "mt5", label: "MT5"},
          {value: "matchtrade", label: "Match-Trader"},
        ];
  }
  const [broker, setBroker] = useState(tradingPlatform[0]);
  const [userSelectedBroker, setUserSelectedBroker] = useState(null); // Track user's manual selection

  useEffect(() => {
    if (userCountry === "Poland") {
      setBroker({value: "mt5", label: "MT5"});
      setUserSelectedBroker(null); // Reset user selection for Poland
    } else if (!userSelectedBroker) {
      // Only auto-select broker if user hasn't manually selected one
      challenges[0]?.id === 13 ? setBroker({value: "matchtrade", label: "Match-Trader"}) : setBroker(tradingPlatform[0]);
    }
  }, [challenges, userCountry, userSelectedBroker]);

  const brandTabItems = [
    {value: "equity_edge", name: "Equity Edge"},
    {value: "crypto_edge", name: "Crypto Edge"},
  ];

  const selectedBrand = useSelector((state) => state.brand.selectedBrand);
  const dispatch = useDispatch();

  const navigate = useNavigate();

  const handleBrandSelector = (value) => {
    dispatch(TOGGLE_Brand(value)); // Single dispatch call
    setTimeout(() => {
      if (window.location.pathname.includes("funding-evaluation") && window.location.pathname.includes("payments")) {
        navigate("/");
      } else {
        // Consider avoiding reload; update state
        window.location.reload();
      }
    }, 500);
  };

  return (
    <>
      {isLoading && <LoaderOverlay />}
      <div
        className="plans-container"
        // style={{marginTop: "100px"}}
      >
        {errorModalOpen && (
          <ErrorModal
            desc={plansRedux.message}
            setModalOpen={setErrorModalOpen}
            btnText="Cancel"
          />
        )}
        {planNames?.length > 0 ? (
          <>
            <div className="plans_header">
              <div className="brand_platform_tabs">
                {/* <div className="brand_tabs_wrapper">
                  {brandTabItems.map((item) => (
                    <div
                      key={item.value}
                      className={`brand_tab ${selectedBrand?.brand === item.value ? "activeBrand" : ""}`}
                      onClick={() => handleBrandSelector(item.value)}
                    >
                      {item.name}
                    </div>
                  ))}
                </div> */}
              </div>

              <div className="plan_tabs_wrapper">
                {/* Plan Name Tabs (Legacy, Flagship, Swift, Instant) */}
                <div
                  className="brand_tabs_wrapper plan_tabs"
                  id="types"
                >
                  {planNames.map((name, inx) => (
                    <div
                      key={name}
                      className={`brand_tab plan_tab ${selectedPlanName === name ? "activeBrand" : ""}`}
                      onClick={() => {
                        setSelectedPlanName(name);
                      }}
                    >
                      {/* plan type badges */}
                      {planBadges[name] && <div className="plan-badge">{planBadges[name]}</div>}
                      {/* plan type labels */}
                      <span style={{textTransform: "capitalize", whiteSpace: "nowrap"}}>{name}</span>
                      {name === "Trading Cup" && <TradingCupInfo />}
                    </div>
                  ))}
                </div>

                {/* Step Tabs (1 Step / 2 Step) - only when available for selected plan */}
                {stepTypes.some((t) => stepLabel(t)) && (
                  <div
                    className="brand_tabs_wrapper plan_tabs"
                    id="steps"
                  >
                    {stepTypes
                      .filter((t) => stepLabel(t))
                      .map((t) => (
                        <div
                          key={t}
                          className={`brand_tab plan_tab ${selectedStepType === t ? "activeBrand" : ""}`}
                          onClick={() => setSelectedStepType(t)}
                        >
                          {stepLabel(t)}
                        </div>
                      ))}
                  </div>
                )}

                {selectedBrand?.brand === "equity_edge" && (
                  <>
                    {userCountry !== "United States" && (
                      <div
                        className="brand_tabs_wrapper plan_tabs"
                        id="steps"
                      >
                        {tradingPlatform?.map((platform) => (
                          <div
                            key={platform.value}
                            className={`brand_tab plan_tab ${broker.value === platform.value ? "activeBrand" : ""}`}
                            onClick={() => {
                              setBroker(platform);
                              setUserSelectedBroker(platform.value); // Track user's manual selection
                            }}
                          >
                            {platform.label}
                          </div>
                        ))}
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
            <div className="plans-subcontainer">
              {/* <TierHeader tier={tier} /> */}
              <div className="plans-plan-container">
                {(!currentPlan || challenges?.length === 0) && (
                  <div style={{padding: 16, textAlign: "center", width: "100%"}}>
                    <span>No challenges available for the selected plan/step.</span>
                  </div>
                )}
                {currentPlan && challenges?.length > 0 && (
                  <Tier
                    broker={broker.value}
                    tiers={currentPlan}
                    activeTier={activeTier}
                    setActiveTier={setActiveTier}
                    setFooterValue={setFooterValue}
                    userCountry={userCountry}
                  />
                )}
              </div>
            </div>
            {/* <PlanFooter tier={footerValue} /> */}
          </>
        ) : (
          <></>
        )}
      </div>
    </>
  );
}

export default Plans;
